module.exports = __webpack_public_path__ + "static/img/list_active.5054e998.svg";